module.exports = {
      id: "logos:certsy-logo-usage",
      viewBox: "0 0 118 35",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#logos:certsy-logo-usage",
      toString: function () {
        return this.url;
      }
    }